const actions = {
    // Settings
    MINIPOS_READ_SETTINGS_REQUEST: 'MINIPOS_READ_SETTINGS_REQUEST',
    MINIPOS_READ_SETTINGS_SUCCESS: 'MINIPOS_READ_SETTINGS_SUCCESS',
    MINIPOS_READ_SETTINGS_ERROR: 'MINIPOS_READ_SETTINGS_ERROR',

    MINIPOS_UPDATE_SETTINGS_REQUEST: 'MINIPOS_UPDATE_SETTINGS_REQUEST',
    MINIPOS_UPDATE_SETTINGS_SUCCESS: 'MINIPOS_UPDATE_SETTINGS_SUCCESS',
    MINIPOS_UPDATE_SETTINGS_ERROR: 'MINIPOS_UPDATE_SETTINGS_ERROR',

    // Orders
    MINIPOS_READ_ALL_ORDERS_REQUEST: 'MINIPOS_READ_ALL_ORDERS_REQUEST',
    MINIPOS_READ_ALL_ORDERS_SUCCESS: 'MINIPOS_READ_ALL_ORDERS_SUCCESS',
    MINIPOS_READ_ALL_ORDERS_ERROR: 'MINIPOS_READ_ALL_ORDERS_ERROR',

    MINIPOS_READ_ORDER_REQUEST: 'MINIPOS_READ_ORDER_REQUEST',
    MINIPOS_READ_ORDER_SUCCESS: 'MINIPOS_READ_ORDER_SUCCESS',
    MINIPOS_READ_ORDER_ERROR: 'MINIPOS_READ_ORDER_ERROR',

    MINIPOS_VOID_ORDER_REQUEST: 'MINIPOS_VOID_ORDER_REQUEST',
    MINIPOS_VOID_ORDER_SUCCESS: 'MINIPOS_VOID_ORDER_SUCCESS',
    MINIPOS_VOID_ORDER_ERROR: 'MINIPOS_VOID_ORDER_ERROR',

    MINIPOS_RESET_STATE: 'MINIPOS_RESET_STATE',

    // Settings
    readMiniPosSettings: () => ({
        type: actions.MINIPOS_READ_SETTINGS_REQUEST,
    }),

    updateMiniPosSettings: request => ({
        type: actions.MINIPOS_UPDATE_SETTINGS_REQUEST,
        request,
    }),

    // Orders
    readAllOrders: request => ({
        type: actions.MINIPOS_READ_ALL_ORDERS_REQUEST,
        request,
    }),

    readOrder: id => ({
        type: actions.MINIPOS_READ_ORDER_REQUEST,
        id,
    }),

    voidOrder: (id, request) => ({
        type: actions.MINIPOS_VOID_ORDER_REQUEST,
        id,
        request,
    }),

    resetMiniPosState: () => ({
        type: actions.MINIPOS_RESET_STATE,
    }),

};
export default actions;
